module.exports = __webpack_public_path__ + "static/img/Neptune.6cda193.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/planet/Neptune.svg
// module id = 1414
// module chunks = 0